export default {
  enumConf: {
    // 广告状态
    AdvertiseStatus: [],
    // 广告来源
    AdvertiseSource: [],
    // 发布填报平台
    PresentPlatformType: [],
    // 推送渠道
    PushChannel: [],
    // 招商下店铺参与状态
    MerchantsPlanShopStatus: [],
    // 招商状态
    MerchantsPlanStatus: [],
    // 影响平台补贴的因素
    MerchantsPlanLayeredSubsidyType: [],
    // 选择目标商户途径
    MerchantsPlanShopFilterType: [],
    // 出价方式
    CostType: [],
  },
  adConf: {
    appHomeConfig: {
      title: '',
      desc: ['', ''],
      image: '',
    },
    appCreateConfig: {
      previewImages: '', // 创建页面预览图
      protocol: '', // 创建页面协议
      merchantsPlanImage: '', // 广告招商报名头图
    },
  },
  // 品牌店铺选择页数据
  brandShopFilter: {
    brandShopOptions: [], // 原始数据（API返回的品牌门店树）
    brandShopMap: {}, // 品牌Map（快速查找）{ brandId: brandObject }
    selectedBrandIds: [], // 选中的品牌ID列表
    selectedShopMap: {}, // 选中的门店Map（按品牌分组）{ brandId: [shopId1, shopId2] }
  },
}
